import { Component, Prop, Vue } from "vue-property-decorator";
import WithRender from "./RequestsSendersPage.html";
import { Inject } from "vue-di-container";
import RequestsSendersService from "./RequestsSendersService";
import SendersByNodesChart from "./components/SendersByNodesChart";
import SendersDurationChart from "./components/SendersDurationChart";
import SenderExpirationTimelineChart from "./components/SenderExpirationTimelineChart";
import SenderRenewalTimelineChart from "./components/SenderRenewalTimelineChart";
import ActiveSendersTimelineChart from "./components/ActiveSendersTimelineChart";
import SenderNameLengthComplianceChart from "./components/SenderNameLengthComplianceChart";
import RequestsBySmsProviderAndSenderTypeChart from "./components/RequestsBySmsProviderAndSenderTypeChart";

@WithRender
@Component({
    components: {
        SendersByNodesChart,
        SendersDurationChart,
        SenderExpirationTimelineChart,
        SenderRenewalTimelineChart,
        ActiveSendersTimelineChart,
        SenderNameLengthComplianceChart,
        RequestsBySmsProviderAndSenderTypeChart,
    },
    diProvide: [RequestsSendersService],
})
export default class RequestsSendersPage extends Vue {
    @Inject(RequestsSendersService)
    public requestsSendersService!: RequestsSendersService;

    @Prop({ required: true }) public filter!: any;
    @Prop({ required: true }) public tenants!: any[];
    private refreshPromise: Promise<void> | null = null;

    public async refresh(): Promise<void> {
        if (this.refreshPromise) {
            return this.refreshPromise;
        }

        const refs = [
            "senderNameLengthCompliance",
            "sendersByNodes",
            "sendersDuration",
            "senderExpirationTimeline",
            "senderRenewalTimeline",
            "activeSendersTimeline",
            "requestsBySmsProviderAndSenderType",
        ];

        this.refreshPromise = Promise.all(refs.map((refName: string) => this.refreshChildByRef(refName))).then(() => undefined);

        try {
            await this.refreshPromise;
        } finally {
            this.refreshPromise = null;
        }
    }

    private async refreshChildByRef(refName: string): Promise<void> {
        const component: any = this.$refs[refName];
        if (component && component.refresh) {
            await component.refresh();
        }
    }
}